import {
    ConsolidatedLocationView,
    EventPanelConfiguration,
    EventPanelFormType,
} from '@mark43/cad-api';
import { FieldPathValue, UseFormReturn } from 'react-hook-form';
import { EventPanelVehicleBaseKey } from '../types';

export function getDefaultVehicle({
    eventPanelConfiguration,
    towedFromLocation,
}: {
    eventPanelConfiguration?: EventPanelConfiguration;
    towedFromLocation?: ConsolidatedLocationView;
    // Enforce that we update the default vehicle anytime new properties are added
}): FieldPathValue<EventPanelFormType, 'towVehicles.0'> {
    return {
        showNcicTowVehicleButton: false,
        plateNumber: null,
        vinNumber: null,
        stateOption: null,
        purposeCode: eventPanelConfiguration?.defaultPurposeCode ?? null,
        queryInDex: false,
        id: null,
        colorOption: null,
        involvementTypeOption: null,
        involvementTypeOther: null,
        towCompanyOption: null,
        towCompanyOther: null,
        towCompanyPhoneNumber: null,
        towedFromLocation: towedFromLocation ?? null,
        towedToLocation: null,
        towTypeOption: null,
        vehicleMakeOption: null,
        vehicleMakeOther: null,
        vehicleModelOption: null,
        vehicleModelOther: null,
        contextId: null,
        year: null,
        notes: null,
        eventInfo: null,
        isRemoved: false,
        isPersisted: false,
        rotationServiceListPositionId: null,
        plateType: eventPanelConfiguration?.defaultPlateType ?? null,
        plateYear: eventPanelConfiguration?.defaultPlateYear ?? null,
        isPrimary: false,
        eventMasterVehicleData: null,
        autoInsuranceCarrier: null,
        isHeld: false,
    };
}

export function getInitialValuesForTowVehicle(
    eventForm: UseFormReturn<EventPanelFormType>,
    baseKey: EventPanelVehicleBaseKey,
    index: number
): Partial<EventPanelFormType['towVehicles'][0]> {
    const [
        vinNumber,
        plateNumber,
        stateOption,
        vehicleMakeOption,
        vehicleModelOption,
        colorOption,
        notes,
        year,
    ] = eventForm.getValues([
        `${baseKey}.${index}.vinNumber`,
        `${baseKey}.${index}.plateNumber`,
        `${baseKey}.${index}.stateOption`,
        `${baseKey}.${index}.vehicleMakeOption`,
        `${baseKey}.${index}.vehicleModelOption`,
        `${baseKey}.${index}.colorOption`,
        `${baseKey}.${index}.notes`,
        `${baseKey}.${index}.year`,
    ]);

    return {
        vinNumber: vinNumber ?? null,
        plateNumber: plateNumber ?? null,
        stateOption: stateOption ?? null,
        vehicleMakeOption: vehicleMakeOption ?? null,
        vehicleModelOption: vehicleModelOption ?? null,
        colorOption: colorOption ?? null,
        notes: notes ?? null,
        year: year ?? null,
    };
}
